export enum PaymentOrderReason {
    SIGNUP = `SIGNUP`,
    RENEWAL = `RENEWAL`,
}